<div>
    <div style="display: flex;">
        <div style="width: 100%">
          <h1 style="font-size: 1.5rem">Experience</h1>
        </div>
    </div>

    <div style="border: 1px solid rgb(225, 219, 219); padding: 20px;">
        Demographic data allows us to decipher different groups and what 
        aspects of their identity, such as age and gender, might 
        influence the way that they respond. It also permits us to 
        understand who are reaching successfully and what proportion 
        of the population we need to work on to ensure 100% inclusivity 
        in the OwlHub Experience
    </div>

    <form [formGroup]="form" >
        <div formArrayName="answers">
            <div style="margin: 2rem;" *ngFor="let questionGroup of answers.controls; let i = index" 
                [formGroupName]="i">
                <label>
                    {{ experience[i].question}}
                    <span *ngIf="i === 0" style="color: red;">*</span>
                </label>
                <mat-radio-group formControlName="answer_id">
                    <mat-radio-button 
                    style="display: block;" 
                    *ngFor="let option of experience[i]?.answers"
                    [value]="option.answer_id">
                        {{ option.answer }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </form>


    <div style="gap: 0.8rem; padding: 0 2rem 1rem">
        <lib-button color="primary" style="padding: 5px;" mat-button (click)="router.navigate(['/'])">Back</lib-button>
        <lib-button color="primary" mat-button (click)="update()">Save</lib-button>
    </div>

</div>